var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    id: "hospital",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1d3d4",
    d: "M25 27a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8ZM1 23V3a2 2 0 0 1 2-2h32a2 2 0 0 1 2 2v20H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M19 25H3a2 2 0 0 1-2-2h20a2 2 0 0 1-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M35 25H19a2 2 0 0 1-2-2h20a2 2 0 0 1-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55acee",
    d: "M35 11H3v4h32v-4zm0 6H3v4h32v-4zm0-12H3v4h32V5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    d: "M29 1H9v24h20V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55acee",
    d: "M27 13H11v4h16v-4zm0 6H11v4h16v-4zm0-12H11v4h16V7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b88c3",
    d: "M24 1H14v4h10V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd2e44",
    d: "M23 33h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M27 27H11a2 2 0 0 1-2-2h20a2 2 0 0 1-2 2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.db2b077feeaa6359555f491c1f497fbb.svg";
export { ForwardRef as ReactComponent };